const makeInitialState = () => {
  return {
    rfc: '',
    name: '',
    maternalName: '',
    paternalName: '',
    phone: '',
    email: '',
    sex: '',
    curp: '',
    indentificationNumber: '',
    existingRfc: false,
  };
};

export default makeInitialState;
